import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const WalletSettingsPanel = ({ settings, onChange }) => {
  const networkOptions = [
    { value: 'polygon-mainnet', label: 'Polygon Mainnet', description: 'Production network' },
    { value: 'polygon-testnet', label: 'Polygon Mumbai', description: 'Test network' },
    { value: 'ethereum-mainnet', label: 'Ethereum Mainnet', description: 'Ethereum L1' }
  ];

  const handleDisconnectWallet = () => {
    localStorage.removeItem('wallet_connected');
    localStorage.removeItem('wallet_address');
    window.location?.reload();
  };

  const truncateAddress = (address) => {
    if (!address) return '';
    return `${address?.slice(0, 6)}...${address?.slice(-4)}`;
  };

  return (
    <div className="space-y-6">
      {/* Connected Wallet */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Icon name="Wallet" size={18} className="text-primary" />
          <h3 className="text-lg font-medium text-foreground">Connected Wallet</h3>
        </div>
        
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Wallet" size={20} color="white" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">MetaMask Wallet</p>
                <p className="text-xs text-muted-foreground font-mono">
                  {truncateAddress(settings?.connectedAddress)}
                </p>
              </div>
            </div>
            <Button 
              variant="outline" 
              size="sm"
              iconName="LogOut"
              onClick={handleDisconnectWallet}
            >
              Disconnect
            </Button>
          </div>
        </div>
      </div>

      {/* Network Preferences */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Icon name="Network" size={18} className="text-primary" />
          <h3 className="text-lg font-medium text-foreground">Network Preferences</h3>
        </div>
        
        <div className="grid gap-4">
          <Select
            label="Default Network"
            value={settings?.networkPreference}
            onChange={(value) => onChange('networkPreference', value)}
            options={networkOptions}
            description="Choose your preferred blockchain network"
          />
        </div>
      </div>

      {/* Gas Fee Settings */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Icon name="Zap" size={18} className="text-primary" />
          <h3 className="text-lg font-medium text-foreground">Gas Fee Settings</h3>
        </div>
        
        <div className="space-y-4">
          <Checkbox
            checked={settings?.autoGasEstimation}
            onChange={(e) => onChange('autoGasEstimation', e?.target?.checked)}
            label="Auto Gas Estimation"
            description="Automatically estimate gas fees for optimal transaction speed"
          />
          
          {!settings?.autoGasEstimation && (
            <Input
              type="number"
              label="Custom Gas Price (Gwei)"
              value={settings?.customGasPrice}
              onChange={(e) => onChange('customGasPrice', e?.target?.value)}
              placeholder="25"
              description="Set a custom gas price in Gwei"
            />
          )}
        </div>
      </div>

      {/* Transaction Settings */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Icon name="ArrowRightLeft" size={18} className="text-primary" />
          <h3 className="text-lg font-medium text-foreground">Transaction Settings</h3>
        </div>
        
        <div className="bg-muted rounded-lg p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Slippage Tolerance:</span>
              <span className="font-medium text-foreground">0.5%</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Transaction Deadline:</span>
              <span className="font-medium text-foreground">10 minutes</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Max Gas Limit:</span>
              <span className="font-medium text-foreground">300,000</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Priority Fee:</span>
              <span className="font-medium text-foreground">Auto</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletSettingsPanel;